import { isNil, isNumber } from 'lodash';
import { GetSitesForMapParams } from './SitesThunks';

export const getParamsForGetSitesForMap = (payload: GetSitesForMapParams) => {
  const { from, to, ...filters } = payload.filter;

  const params = new URLSearchParams(filters as Record<string, string>);

  from && params.append('calledInFilter.From', from);
  to && params.append('calledInFilter.To', to);

  params.append('includeArchived', payload.includeArchived?.toString());

  payload.accountId && params.append('accountId', payload.accountId.toString());
  isNumber(payload.pointOneLatitude) && params.append('pointOneLatitude', payload.pointOneLatitude.toString());
  isNumber(payload.pointOneLongitude) && params.append('pointOneLongitude', payload.pointOneLongitude.toString());
  isNumber(payload.pointTwoLatitude) && params.append('pointTwoLatitude', payload.pointTwoLatitude.toString());
  isNumber(payload.pointTwoLongitude) && params.append('pointTwoLongitude', payload.pointTwoLongitude.toString());
  params.append('directlyAssociated', 'false');
  payload.showFlowSites && params.append('showFlowSites', payload.showFlowSites.toString());
  payload.showFlowAndPressureSites &&
    params.append('showFlowAndPressureSites', payload.showFlowAndPressureSites.toString());
  payload.showPressureSites && params.append('showPressureSites', payload.showPressureSites.toString());
  payload.showPrvSites && params.append('showPrvSites', payload.showPrvSites.toString());
  !isNil(payload.showSitesWithInvalidLocation) &&
    params.append('showSitesWithInvalidLocation', payload.showSitesWithInvalidLocation?.toString());

  return params;
};
